/**
 * Shared helpers for React Query hooks and URL building from filters.
 */

/**
 * Returns query options with periodic polling disabled.
 *
 * @param {Object} options - Hook options
 * @returns {Object} options with polling disabled
 */
export function pollingOptions(options = {}) {
  const { enablePolling, refetchInterval, refetchIntervalInBackground, ...queryOptions } = options;

  return {
    refetchInterval: false,
    refetchIntervalInBackground: false,
    ...queryOptions,
  };
}

/**
 * Builds a URL with optional query string from a filters object.
 * Omits the "?" when there are no params.
 *
 * @param {string} baseUrl - Path or full base URL (no query string)
 * @param {Object} filters - Key-value pairs for query params
 * @param {{ clean?: boolean }} [opts] - If clean: true, strip undefined/null/empty values
 * @returns {string} baseUrl or baseUrl?params
 */
export function buildUrlWithParams(baseUrl, filters = {}, opts = {}) {
  let source = filters;
  if (opts.clean) {
    source = Object.fromEntries(
      Object.entries(filters).filter(([, v]) => v !== undefined && v !== null && v !== ""),
    );
  }
  const params = new URLSearchParams(source);
  const query = params.toString();
  return query ? `${baseUrl}?${query}` : baseUrl;
}
